import { AssessmentEditProvider } from "../context/AssessmentEditContext";
import { AssessmentEditDetailsOrganism } from "../organisms/AssessmentEditDetailsOrganism";
import { AssessmentEditSaveChangesOrganism } from "../organisms/AssessmentEditSaveChangesOrganism";
import { AssessmentEditPagesOrganism } from "../organisms/AssessmentEditPagesOrganism";
import { View } from "ui/atoms/view";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";

interface Props {
  id?: number;
}
export function AssessmentEditTemplate({ id }: Props) {
  return (
    <AssessmentEditProvider
      id={id}
      loadingFallback={
        <View className="flex-1 items-center justify-center">
          <LoadingSpinner />
        </View>
      }
    >
      <AssessmentEditDetailsOrganism className="mb-8" />
      <AssessmentEditPagesOrganism />
      <AssessmentEditSaveChangesOrganism />
    </AssessmentEditProvider>
  );
}
